<app-dialog-container
  title="{{ 'manageAccessAndResponsible' | translate }}"
  [isValid]="form.valid"
  (confirmButtonHandler)="save()"
>
  <form [formGroup]="form">
    <app-ui-slide-toggle
      label="{{ 'shouldOverwriteAccess' | translate }}"
      [control]="form.shouldOverwriteAccess"
      [matTooltip]="'shouldOverwriteAccessTooltipDescription' | translate"
    ></app-ui-slide-toggle>
    <app-ui-slide-toggle
      label="{{ 'isRecursive' | translate }}"
      [control]="form.isRecursive"
      [matTooltip]="'isRecursiveTooltipDescription' | translate"
    ></app-ui-slide-toggle>
    <div>
      <app-job-position-and-group-multiselect
        [positionFieldName]="'accessPositions'"
        [positionGroupFieldName]="'accessPositionGroups'"
        rolesFieldName="accessRoles"
        [form]="form"
        [required]="false"
        [positionsOnlyForSelectedDep]="true"
        label="{{ 'access' | translate }}"
      ></app-job-position-and-group-multiselect>
      <app-job-position-and-group-multiselect
        [positionFieldName]="'responsibleForPositions'"
        [positionGroupFieldName]="'responsibleForPositionGroups'"
        rolesFieldName="responsibleForRoles"
        [form]="form"
        [required]="false"
        [positionsOnlyForSelectedDep]="true"
        [skipDispatch]="true"
        label="{{ 'responsible' | translate }}"
      ></app-job-position-and-group-multiselect>
    </div>
  </form>
</app-dialog-container>
